/** Общие опции шторки «Фильтры». */
export type FilterOption = { value: string; label: string; count?: number; muted?: boolean };

export const ALL_TURKEY = "all";
export const ALL_TURKEY_LABEL = "Вся Турция";

/** Список городов для секции «Город»: первым всегда «Вся Турция» (без фильтра). */
export function cityFilterOptions(cities: readonly string[]): FilterOption[] {
  const seen = new Set<string>();
  const rest: FilterOption[] = [];
  for (const c of cities) {
    const v = c?.trim();
    if (!v || v === ALL_TURKEY || v === ALL_TURKEY_LABEL || v === "Не указан" || seen.has(v)) continue;
    seen.add(v);
    rest.push({ value: v, label: v });
  }
  return [{ value: ALL_TURKEY, label: ALL_TURKEY_LABEL }, ...rest];
}

/** Опции «Направление»: первым «Все направления», рядом счётчик, нули приглушены. */
export function categoryFilterOptions(
  cats: readonly string[],
  counts: Record<string, number>,
  allLabel = "Все направления",
): FilterOption[] {
  return [
    { value: "", label: allLabel },
    ...cats.map((c) => ({
      value: c,
      label: c,
      count: counts[c] ?? 0,
      muted: (counts[c] ?? 0) === 0,
    })),
  ];
}
